import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IOrderStatsParams, IOrderStatsItem, IOrderStatsViaSceneParams, IOrderStatsViaSceneItem, IIOrderTransactionRecodingContext, IOrderTransactionRecodingParams, ICompanyBusinessSummaryParams, ICompanyBusinessSummary } from '../../../types/air-splitting/data-statistics/dataStatistics';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 数据统计 - 汇总统计
 */
export async function queryOrderStats(params: IOrderStatsParams) {
  let data = [] as IOrderStatsItem[];
  let total = 0;
  
  params = JSON.parse(JSON.stringify(params)) as IOrderStatsParams;
  
  try {
    const { code, context, message } = await Http.get<{ data: IOrderStatsItem[]; total: number }>(`${hostUrl}/pay/air-bill/order-stats/query-order-stats`, params);
  
    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IOrderStatsItem[]; total: number };
  
      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  
  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 数据统计 - 汇总统计导出
 */
export async function exportOrderStats(param: IOrderStatsParams) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/pay/air-bill/order-stats/export-order-stats`,
      param,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName, 
  };
}

/**
 * 空中分账 - 数据统计 - 业务场景汇总统计
 */
export async function queryOrderStatsViaScene(params: IOrderStatsViaSceneParams) {
  let data = [] as IOrderStatsViaSceneItem[];
  let total = 0;
  
  params = JSON.parse(JSON.stringify(params)) as IOrderStatsViaSceneParams;
  
  try {
    const { code, context, message } = await Http.get<{ data: IOrderStatsViaSceneItem[]; total: number }>(`${hostUrl}/pay/air-bill/order-stats/query-order-stats-via-scene`, params);
  
    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IOrderStatsViaSceneItem[]; total: number };
  
      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  
  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 数据统计 - 汇总统计导出
 */
export async function exportOrderStatsViaScene(param: IOrderStatsViaSceneParams) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/pay/air-bill/order-stats/export-order-stats-via-scene`,
      param,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName, 
  };
}

/**
 * 空中分账 - 数据统计 - 收支流水明细
 */
export async function queryOrderTransactionRecoding(params: IOrderTransactionRecodingParams) {
  let context = {} as IIOrderTransactionRecodingContext;
  
  params = JSON.parse(JSON.stringify(params)) as IOrderTransactionRecodingParams;
  
  try {
    const { code, context: contextData, message } = await Http.get<IIOrderTransactionRecodingContext>(`${hostUrl}/pay/order-transaction-recoding/query`, params);
  
    if (code === EAxiosResponseCode.Succeed) {
      context = contextData || {} as IIOrderTransactionRecodingContext;
      context.data = contextData.data || [];
      context.total = contextData.total || 0;

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  
  return context;
}

/**
 * 空中分账 - 数据统计 - 收支流水明细导出
 */
export async function exportOrderTransactionRecoding(param: IOrderTransactionRecodingParams) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/pay/order-transaction-recoding/export`,
      param,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName, 
  };
}

/**
 * 空中分账 - 数据统计 - 企业营收统计
 */
export async function queryCompanyBusinessSummary(params: ICompanyBusinessSummaryParams) {
  let data = [] as ICompanyBusinessSummary[];
  let total = 0;
  
  params = JSON.parse(JSON.stringify(params)) as ICompanyBusinessSummaryParams;
  
  try {
    const { code, context, message } = await Http.post<{ data: ICompanyBusinessSummary[]; total: number }>(
      `${hostUrl}/pay/air-bill/order-stats/query-company-business-summary`, 
      params,
    );
  
    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ICompanyBusinessSummary[]; total: number };
  
      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  
  return {
    data,
    total, 
  };
}

/**
 * 空中分账 - 数据统计 - 企业营收统计导出
 */
export async function exportCompanyBusinessSummary(param: ICompanyBusinessSummaryParams) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.post<Blob>(
      `${hostUrl}/pay/air-bill/order-stats/export-company-business-summary`,
      param,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName, 
  };
}
